import { writeStorage } from "@rehooks/local-storage";

const ChangeTitle = (topBar) => {
    writeStorage("topBar", topBar);
};

export default ChangeTitle;
